const common = {
  serverError: "Lỗi máy chủ",
  networkError: "Lỗi mạng",

  del: "xóa",
  rmTip: "Xóa mẹo",
  rmContent: "Bạn có chắc chắn muốn xóa dữ liệu này không? Dữ liệu không thể phục hồi sau khi xóa! ",
  rmError: "Xóa không thành công",
  rmSuccess: "Xóa thành công",

  confirm: "Được",
  cancel: "hủy",
  cancelConfirm: "Dữ liệu đã được thay đổi, bạn có chắc chắn không muốn lưu nó không? ",

  add: "Thêm",
  addError: "Thêm không thành công",
  addSuccess: "Thêm thành công",

  edit: "chỉnh sửa",
  editError: "Chỉnh sửa không thành công",
  editSuccess: "Chỉnh sửa thành công",
  tip: "mẹo",

  opt: "hoạt động",
  viewDetail: "Xem chi tiết",
  detail: "Chi tiết",

  desc: "mô tả",
  plDesc: "Xin vui lòng nhập mô tả",

  pass: "vượt qua",
  no: "Không",
  copy: "sao chép",
  copyError: ' sao chép thất bại',
  copySuccess: ' sao chép thành công',

  printInfo: "In",
  printInfoQC: 'In phiếu kiểm tra QC',
  paste: "dán",
  pasteError: "Dán không thành công, vui lòng xác nhận rằng nội dung được sao chép là bình thường hoặc sao chép lại và thử lại",

  select: 'Chọn',
  searchError: "Lấy danh sách ngoại lệ",

  timeOption12: "12 giờ",
  timeOption24: "1 ngày",
  timeOption36: "36 giờ",
  timeOption48: "2 ngày",
  timeOption72: "3 ngày",
  timeOption96: "4 ngày",
  timeOption120: "5 ngày",
  currentTime: "Thời gian hiện tại",
  selectTime: "Vui lòng chọn hoặc điền vào khoảng thời gian có sẵn cho báo giá của nhà cung cấp",
  or: "hoặc",
  inputHours: "Nhập giờ",
  hour: 'giờ',
  finalEnd: "Thời hạn báo giá cuối cùng",
  upper: "Sau khi hoàn thiện thời gian hiện tại",
  Thêm: "Thêm vào",

  refresh: "Làm mới",
  sure: 'Bạn chắc chắn muốn tiết kiệm?',
  saveOk: 'Lưu thành công',
  saveFAil: 'Lưu thất bại',
  save: 'Lưu',
  notSave: 'Không lưu',
  validateFailed: 'Xác thực biểu mẫu thất bại',

  createTime: "Thời gian tạo đơn",
  creator: "Người tạo đơn",
  updateTime: 'Thời gian cập nhật',
  updater: 'Người cập nhật',
  pleaseTryAgain: 'Vui lòng thử lại sau',
  operationFailed: 'Thao tác thất bại',

  exportCurrentPage: 'Xuất trang hiện tại sang Excel',
  exportAllExcel: 'Xuất tất cả sang Excel',
  exporting: 'Đang xuất',
  exportingTip: 'Đang tải dữ liệu theo lô, vui lòng đợi...',
  exportErr: 'Xuất thất bại',
  warning: 'Cảnh báo',
  pleaseSelectColumns: 'Vui lòng chọn ít nhất một cột để xuất',
  selectAll: 'Chọn tất cả',
  expand: 'Mở rộng',
  collapse: 'Thu gọn',

  basicInfo: 'Thông tin cơ bản',
  attachment: 'Đính kèm',
  noOutOrder: 'Không có đơn xuất kho',
  deleteSuccess: 'Xóa thành công',
  deleteFail: 'Xóa thất bại',
  batchDel: 'Xóa hàng loạt',
  selectLeastOne: 'Vui lòng chọn ít nhất một mục',
  versionFalse: "Yêu cầu thất bại. Phiên bản của bạn không chính xác. Vui lòng làm mới trang và thử lại.",
  po: "Đơn mua hàng",
  poi: "Dòng đơn mua hàng",
  so: "Đơn bán hàng",
  soi: "Dòng đơn bán hàng",
  io: "Đơn nhập kho",
  ioi: "Dòng đơn nhập kho",
  oo: "Đơn xuất kho",
  ooi: "Dòng đơn xuất kho",
  co: "Đơn kiểm kê",
  coi: "Dòng đơn kiểm kê",
  act: "Phải thu",
  acti: "Dòng phải thu",
  pay: "Phải trả",
  payi: "Dòng phải trả",
  req: "Đơn nhu cầu",
  reqi: "Dòng đơn nhu cầu",
  quo: "Đơn thăm dò",
  loc: "Vị trí kho",
  sp: "Giá bán",
  pp: "Giá mua",
  cd: "Chênh lệch kiểm kê",
  user: "Người dùng",
  org: "Tổ chức",
  supplier: "Nhà cung cấp",
  bom: "BOM",
  pl: "Kế hoạch sản xuất",
  reqest: "Yêu cầu",
  export: "Xuất",
  inventories: "Phiếu giao hàng",
  matPurTmp: "Tải mẫu khớp đơn mua hàng",
  genPuInv: "Khớp đơn mua hàng tạo phiếu giao hàng",
  suppInv: "Khớp nhà cung cấp tạo phiếu giao hàng",
  printSaleIn: "In nhập kho thành phẩm",
  saleIn: "Nhập kho thành phẩm",
  lotGetErr: "Tạo lô thất bại, vui lòng liên hệ quản trị viên",
  addNext: "Tiếp theo",
  genLot: "Tạo",
  noCodeWarn: "Các mục không có mã hàng tồn kho sẽ không tạo lô",
  genAllLot: "Tạo tất cả lô",
  colSet: "Chọn cột hiển thị",
  leastSetOneCol: "Chọn ít nhất một cột để hiển thị!",
  reqCanceled: "Yêu cầu truy vấn đã bị hủy",
  escPressed: "Bạn đã nhấn ESC, yêu cầu truy vấn đã bị hủy",
  noFiles: "Không có tệp",
};

export default common;
